/**
 * Utility functions for generating Etherscan links and handling blockchain explorer integration
 */

// Get the Etherscan base URL from environment variables
const ETHERSCAN_BASE_URL = process.env.REACT_APP_ETHERSCAN_BASE_URL || "https://sepolia.etherscan.io";

/**
 * Generate a link to view a transaction on Etherscan
 * @param txHash - The transaction hash
 * @returns The full Etherscan URL for the transaction
 */
export function getEtherscanTxLink(txHash: string): string {
  return `${ETHERSCAN_BASE_URL}/tx/${txHash}`;
}

/**
 * Generate a link to view an address on Etherscan
 * @param address - The Ethereum address
 * @returns The full Etherscan URL for the address
 */
export function getEtherscanAddressLink(address: string): string {
  return `${ETHERSCAN_BASE_URL}/address/${address}`;
}

/**
 * Generate a link to view a contract on Etherscan
 * @param contractAddress - The contract address
 * @returns The full Etherscan URL for the contract
 */
export function getEtherscanContractLink(contractAddress: string): string {
  return `${ETHERSCAN_BASE_URL}/address/${contractAddress}#code`;
}

/**
 * Format a transaction hash for display (show first 6 and last 4 characters)
 * @param txHash - The full transaction hash
 * @returns Formatted transaction hash
 */
export function formatTxHash(txHash: string): string {
  if (!txHash || txHash.length < 10) return txHash;
  return `${txHash.substring(0, 6)}...${txHash.substring(txHash.length - 4)}`;
}

/**
 * Format an address for display (show first 6 and last 4 characters)
 * @param address - The full Ethereum address
 * @returns Formatted address
 */
export function formatAddress(address: string): string {
  if (!address || address.length < 10) return address;
  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
}